const CSM_ASSIGNMENT_REASONS = {
  TEACHER_ASSIGNED: 'TEACHER_ASSIGNED',
  TEACHER_TRANSFERRED: 'TEACHER_TRANSFERRED',
  TEACHER_RM_CHANGE: 'TEACHER_RM_CHANGE',
  TEACHER_INACTIVE: 'TEACHER_INACTIVE',
  TEACHER_RM_ASSIGNED: 'TEACHER_RM_ASSIGNED',
  STUDENT_INACTIVE: 'STUDENT_INACTIVE',
  ADMIN_REQUEST: 'ADMIN_REQUEST',
};

export const CSM_ASSIGNMENT_REASONS_OPTIONS = [
  {
    label: 'Teacher assigned',
    value: CSM_ASSIGNMENT_REASONS.TEACHER_ASSIGNED,
  },
  {
    label: 'Teacher transferred',
    value: CSM_ASSIGNMENT_REASONS.TEACHER_TRANSFERRED,
  },
  {
    label: 'Teacher CSM change',
    value: CSM_ASSIGNMENT_REASONS.TEACHER_RM_CHANGE,
  },
  {
    label: 'Teacher inactive',
    value: CSM_ASSIGNMENT_REASONS.TEACHER_INACTIVE,
  },
  {
    label: 'Teacher CSM assigned',
    value: CSM_ASSIGNMENT_REASONS.TEACHER_RM_ASSIGNED,
  },
  {
    label: 'Student inactive',
    value: CSM_ASSIGNMENT_REASONS.STUDENT_INACTIVE,
  },
  {
    label: 'Admin request',
    value: CSM_ASSIGNMENT_REASONS.ADMIN_REQUEST,
  },
];
